import { render } from "./MobileNavigation.vue?vue&type=template&id=4589f8f9&ts=true"
import script from "./MobileNavigation.vue?vue&type=script&lang=ts"
export * from "./MobileNavigation.vue?vue&type=script&lang=ts"

import "./MobileNavigation.vue?vue&type=style&index=0&id=4589f8f9&lang=scss"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__